;(function () {
  /*
   * ボタンが現在クリックできない状態かを判定
   * ※カート追加中の一時的なdisabledも含みます
   */
  function isButtonDisabled(el) {
    if (!el) return true;

    return (
      el.disabled ||
      el.getAttribute("aria-disabled") === "true" ||
      el.getAttribute("disabled") !== null
    );
  }

  /*
   * 本当に在庫切れの商品かを判定
   * disabledだけでは判定しません
   */
  function isButtonUnavailable(el) {
    if (!el) return true;

    const tag = (el.tagName || "").toLowerCase();
    const text =
      tag === "input"
        ? el.value || ""
        : el.textContent || "";

    const normalizedText = text
      .replace(/\s+/g, "")
      .toLowerCase();

    return (
      normalizedText.includes("入荷待ち") ||
      normalizedText.includes("売り切れ") ||
      normalizedText.includes("売切れ") ||
      normalizedText.includes("soldout")
    );
  }

  /*
   * 通常の「カートに入れる」ボタンを
   * ユーザーがクリックした時に近い形で実行
   */
  function fireLikeUser(el) {
    if (!el || isButtonDisabled(el)) return false;

    ["pointerdown", "mousedown", "mouseup", "click"].forEach((type) =>
      el.dispatchEvent(
        new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      )
    );

    return true;
  }

  /*
   * Shadow DOM内も含めて要素を検索
   */
  function deepFindAll(selectors) {
    const results = [];
    const selectorList = Array.isArray(selectors)
      ? selectors
      : [selectors];

    function collectFrom(root) {
      selectorList.forEach((sel) => {
        try {
          results.push(...root.querySelectorAll(sel));
        } catch (_) {}
      });

      const all = root.querySelectorAll
        ? root.querySelectorAll("*")
        : [];

      for (const el of all) {
        if (el.shadowRoot) {
          collectFrom(el.shadowRoot);
        }
      }
    }

    collectFrom(document);

    return results;
  }

  /*
   * 商品ページ本体の「カートに入れる」ボタンを探す
   */
  function findAddToCartButton() {
    const inForms = deepFindAll([
      "form[action*='/cart/add'] button[type='submit']",
      "form[action*='/cart/add'] input[type='submit']",
    ]);

    /*
     * まずクリック可能なボタンを優先
     */
    const enabled = inForms.find(
      (button) => !isButtonDisabled(button)
    );

    if (enabled) return enabled;

    /*
     * 在庫切れなどでdisabledの場合も
     * 状態判定のために取得
     */
    if (inForms[0]) return inForms[0];

    const candidates = deepFindAll([
      "button",
      "input[type='submit']",
      "[role='button']",
    ]);

    const textHit = candidates.find((el) => {
      /*
       * 追従ボタン自身は除外
       */
      if (el.id === "stickyAddToCartCta") {
        return false;
      }

      const tag = (el.tagName || "").toLowerCase();

      const text =
        tag === "input"
          ? el.value || ""
          : el.textContent || "";

      const normalizedText = text
        .replace(/\s+/g, "")
        .toLowerCase();

      return (
        normalizedText.includes("カートに追加") ||
        normalizedText.includes("カートへ追加") ||
        normalizedText.includes("カートに入れる") ||
        normalizedText.includes("addtocart")
      );
    });

    return textHit || null;
  }

  /*
   * 通常のカートボタンが一時的にdisabledの場合、
   * 少し待ってから再試行
   */
  function addToCartWithRetry(onComplete) {
    let tries = 0;
    let finished = false;

    const finish = (success) => {
      if (finished) return;

      finished = true;

      if (typeof onComplete === "function") {
        onComplete(success);
      }
    };

    const timer = setInterval(() => {
      tries++;

      const button = findAddToCartButton();

      /*
       * 本当に在庫切れになった場合
       */
      if (button && isButtonUnavailable(button)) {
        clearInterval(timer);
        finish(false);
        return;
      }

      /*
       * クリック可能になったら実行
       */
      if (
        button &&
        !isButtonDisabled(button) &&
        fireLikeUser(button)
      ) {
        clearInterval(timer);
        finish(true);
        return;
      }

      /*
       * 約5秒試しても実行できなければ終了
       */
      if (tries > 50) {
        clearInterval(timer);
        finish(false);
      }
    }, 100);
  }

  function buildStickyBar() {
    /*
     * PCでは表示しない
     */
    if (window.innerWidth >= 990) {
      return true;
    }

    /*
     * 商品ページ以外では表示しない
     */
    const isProductPage =
      document.querySelector("product-form") ||
      document.querySelector(
        'form[action*="/cart/add"]'
      );

    if (!isProductPage) {
      return true;
    }

    /*
     * カートページでは表示しない
     */
    if (window.location.pathname === "/cart") {
      return true;
    }

    /*
     * 二重生成を防止
     */
    if (
      document.getElementById("miharuStickyBar")
    ) {
      return true;
    }

    const originalButton =
      findAddToCartButton();

    const radius = originalButton
      ? window.getComputedStyle(originalButton)
          .borderRadius
      : "14px";

    /*
     * 追従エリア
     */
    const bar = document.createElement("div");

    bar.id = "miharuStickyBar";

    bar.style.position = "fixed";
    bar.style.left = "0";
    bar.style.right = "0";
    bar.style.bottom = "0";
    bar.style.zIndex = "999";
    bar.style.padding = "10px 12px";
    bar.style.background = "#fff";
    bar.style.borderTop =
      "1px solid rgba(0,0,0,.08)";

    /*
     * 追従カートボタン
     */
    const cartBtn =
      document.createElement("button");

    cartBtn.type = "button";
    cartBtn.id = "stickyAddToCartCta";
    cartBtn.textContent =
      "カートに入れる";

    cartBtn.dataset.loading = "false";

    cartBtn.style.width = "100%";
    cartBtn.style.height = "48px";

    cartBtn.style.transition =
      "transform .12s ease, opacity .12s ease";

    cartBtn.style.setProperty(
      "border-radius",
      radius,
      "important"
    );

    cartBtn.style.setProperty(
      "font-size",
      "15px",
      "important"
    );

    cartBtn.style.setProperty(
      "font-weight",
      "600",
      "important"
    );

    cartBtn.style.setProperty(
      "color",
      "#fff",
      "important"
    );

    cartBtn.style.setProperty(
      "border",
      "none",
      "important"
    );

    /*
     * 在庫あり
     */
    function setAvailableState() {
      if (
        cartBtn.dataset.loading === "true"
      ) {
        return;
      }

      cartBtn.dataset.loading = "false";

      cartBtn.disabled = false;

      cartBtn.removeAttribute(
        "aria-disabled"
      );

      cartBtn.textContent =
        "カートに入れる";

      cartBtn.style.transform =
        "scale(1)";

      cartBtn.style.cursor =
        "pointer";

      cartBtn.style.pointerEvents =
        "auto";

      cartBtn.style.opacity = "1";

      cartBtn.style.setProperty(
        "background-color",
        "#477A35",
        "important"
      );
    }

    /*
     * 在庫なし
     */
    function setUnavailableState() {
      cartBtn.dataset.loading = "false";

      cartBtn.disabled = true;

      cartBtn.setAttribute(
        "aria-disabled",
        "true"
      );

      cartBtn.textContent =
        "入荷待ち";

      cartBtn.style.transform =
        "scale(1)";

      cartBtn.style.cursor =
        "not-allowed";

      cartBtn.style.pointerEvents =
        "none";

      cartBtn.style.opacity = "1";

      cartBtn.style.setProperty(
        "background-color",
        "#e4ebdf",
        "important"
      );
    }

    /*
     * カート追加中
     */
    function setLoadingState() {
      cartBtn.dataset.loading = "true";

      cartBtn.disabled = true;

      cartBtn.setAttribute(
        "aria-disabled",
        "true"
      );

      cartBtn.textContent =
        "追加中...";

      cartBtn.style.cursor =
        "default";

      cartBtn.style.pointerEvents =
        "none";

      cartBtn.style.transform =
        "scale(0.97)";

      cartBtn.style.opacity =
        "0.85";

      setTimeout(() => {
        cartBtn.style.transform =
          "scale(1)";

        cartBtn.style.opacity =
          "1";
      }, 150);
    }

    /*
     * 本体ボタンと在庫状態を同期
     */
    function syncInventoryState() {
      /*
       * カート追加中は本体ボタンが
       * 一時的にdisabledになっても無視
       */
      if (
        cartBtn.dataset.loading === "true"
      ) {
        return;
      }

      const mainButton =
        findAddToCartButton();

      if (!mainButton) return;

      if (
        isButtonUnavailable(mainButton)
      ) {
        setUnavailableState();
      } else {
        setAvailableState();
      }
    }

    /*
     * 追従ボタンをクリック
     */
    cartBtn.addEventListener(
      "click",
      function () {
        if (
          cartBtn.dataset.loading === "true"
        ) {
          return;
        }

        const mainButton =
          findAddToCartButton();

        /*
         * 本当に在庫切れの場合のみ
         * 入荷待ちにする
         */
        if (
          !mainButton ||
          isButtonUnavailable(mainButton)
        ) {
          setUnavailableState();
          return;
        }

        setLoadingState();

        addToCartWithRetry((success) => {
          /*
           * 少し待ってShopify側の状態更新を
           * 完了させてから再判定
           */
          setTimeout(() => {
            cartBtn.dataset.loading =
              "false";

            const currentButton =
              findAddToCartButton();

            if (
              currentButton &&
              isButtonUnavailable(
                currentButton
              )
            ) {
              setUnavailableState();
            } else {
              setAvailableState();
            }
          }, success ? 700 : 200);
        });
      }
    );

    bar.appendChild(cartBtn);
    document.body.appendChild(bar);

    /*
     * 初回表示時
     */
    syncInventoryState();

    /*
     * バリエーション変更などによる
     * 本体ボタンの状態変更を監視
     */
    const productArea =
      document.querySelector(
        "product-info"
      ) ||
      document.querySelector(
        ".product"
      ) ||
      document.body;

    let syncScheduled = false;

    const observer =
      new MutationObserver(() => {
        if (syncScheduled) return;

        syncScheduled = true;

        requestAnimationFrame(() => {
          syncScheduled = false;
          syncInventoryState();
        });
      });

    observer.observe(productArea, {
      attributes: true,

      attributeFilter: [
        "disabled",
        "aria-disabled",
        "class",
      ],

      childList: true,
      subtree: true,
    });

    /*
     * 追従バーの高さ分だけ
     * ページ下部に余白を確保
     */
    const setPadding = () => {
      const height =
        bar.getBoundingClientRect()
          .height || 0;

      document.body.style.paddingBottom =
        Math.ceil(height + 12) + "px";
    };

    setPadding();

    window.addEventListener(
      "resize",
      setPadding
    );

    return true;
  }

  /*
   * 商品フォームの読み込みを待って初期化
   */
  function init() {
    let tries = 0;

    const timer = setInterval(() => {
      tries++;

      const ok = buildStickyBar();

      if (ok || tries > 30) {
        clearInterval(timer);
      }
    }, 100);
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();